<template>
  <v-app>
    <!-- <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="closeSnack">
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
    <v-app-bar
      elevation="0"
      app
      class="color-toptap"
      v-if="
        $router.currentRoute.path != '/' &&
        $router.currentRoute.path != '/login' &&
        $router.currentRoute.path != '/changepassword' &&
        !$router.currentRoute.path.includes('newpassword') &&
        $router.currentRoute.path != '/reset' &&
        $router.currentRoute.path != '/portal'
      "
      dark
      id="appbarnavicon"
    >
      <v-app-bar-nav-icon
        class="color-toptaphamburger"
        @click.stop="drawer = !drawer"
        v-if="
          $router.currentRoute.path != '/' &&
          $router.currentRoute.path != '/reset' &&
          !$router.currentRoute.path.includes('newpassword') &&
          $router.currentRoute.path != '/login'
        "
      >
      </v-app-bar-nav-icon>

      <v-toolbar-title
        class="color-toptaptext"
        v-if="!isMobile"
        style="font-family: Kanit"
      >
        {{ this.$VUE_APP_SYSTEM_NAME_LONG }}
      </v-toolbar-title>
      <v-toolbar-title
        class="color-toptaptext"
        v-if="isMobile"
        style="font-family: Kanit"
        >{{ systemNameShort }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <v-icon class="pr-4">
        mdi-magnify ./assets/Backgorund.jpg
        src="https://picsum.photos/1920/1080?random"
         src="https://picsum.photos/1920/1080?random"
      </v-icon> -->
      <p
        class="mt-4 mr-3 color-toptaptext"
        style="font-family: Kanit; color: #6a707e; font-size: 1.2em"
        v-if="username && (!isMobile || isTablet)"
      >
        {{ username }}
      </p>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon
              v-if="
                $router.currentRoute.path != '/' &&
                $router.currentRoute.path != '/login' &&
                !$router.currentRoute.path.includes('newpassword') &&
                $router.currentRoute.path != '/reset' &&
                $router.currentRoute.path != '/changepassword'
              "
            >
              mdi-account-circle
            </v-icon>
          </v-btn>
        </template>
        <v-list
          style="font-family: Kanit; padding: 0px !important"
          light
          class="p-0"
        >
          <v-list-item @click="goToEditUser">
            <v-list-item-title id="edituser" class="subtitle-2">
              <v-row class="ma-0">
                <v-icon medium color="darken-2" style="color: #000000ad">
                  mdi mdi-grease-pencil
                </v-icon>
                <p id="editusertitle" class="ml-3 mt-3 sidenavbar">
                  แก้ไขข้อมูล
                </p>
              </v-row>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="fnChangePassword" v-if="!isAD">
            <v-list-item-title id="changepassword" class="subtitle-2">
              <v-row class="ma-0">
                <img
                  class="mt-3"
                  width="22px"
                  height="22px"
                  src="./assets/baseline_cached_black_18dp.png"
                />
                <p id="logouttitle" class="ml-3 mt-3 sidenavbar">
                  เปลี่ยนรหัสผ่าน
                </p>
              </v-row>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="logOut">
            <v-list-item-title id="logout" class="subtitle-2">
              <v-row class="ma-0">
                <img
                  class="mt-3"
                  width="22px"
                  height="22px"
                  src="./assets/menu_Left/Group-1.png"
                />
                <p id="logouttitle" class="ml-3 mt-3 sidenavbar">ออกจากระบบ</p>
              </v-row>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- <v-navigation-drawer src="https://picsum.photos/1920/1080?random" v-model="drawer" app fixed temporary light> 
    (!isMobile || (isMobile && drawer == true))-->
    <v-navigation-drawer
      style="font-size: 1.3em"
      @click="drawer = !drawer"
      v-if="
        $router.currentRoute.path != '/' &&
        $router.currentRoute.path != '/login' &&
        $router.currentRoute.path != '/reset' &&
        !$router.currentRoute.path.includes('newpassword') &&
        $router.currentRoute.path != '/changepassword'
      "
      :width="isMobile ? 270 : 280"
      v-model="drawer"
      app
      light
      temporary
    >
      <template v-slot:prepend>
        <v-list-item class="color-topheadsystem pt-2 pb-2">
          <img drak width="30px" height="40px" src="./assets/logo.png" />

          <h3
            class="pl-3 white--text font-weight-bold"
            style="font-family: Kanit"
          >
            ระบบสารบรรณ
          </h3>
        </v-list-item>
      </template>
      <v-list style="font-family: Kanit" light>
        <v-list-item-group v-model="group" active-class="cyan lighten-5">
          <div>
            <v-list-item @click="goTo('/worklist')">
              <v-list-item-title id="worklist" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group 50.png"
                  />
                  <p id="worklisttitle" class="ml-3 mt-3 sidenavbar">
                    หน้าหลัก
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="goTo('/draft')">
              <v-list-item-title id="draft" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Frame.png"
                  />
                  <p id="drafttitle" class="ml-3 mt-3 sidenavbar">ร่างเอกสาร</p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="goTo('/savemessage')">
              <v-list-item-title id="savemessage" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group 80.png"
                  />
                  <p id="savemessagetitle" class="ml-3 mt-3 sidenavbar">
                    บันทึกข้อความ
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="goTo('/receivenote')"
              v-if="
                (this.$VUE_APP_INBOUND_SARABAN && userrole == 'sarabun') ||
                !this.$VUE_APP_INBOUND_SARABAN
              "
            >
              <v-list-item-title id="receivenote" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group.png"
                  />
                  <p id="receivenotetitle" class="ml-3 mt-3 sidenavbar">
                    หนังสือรับเข้า
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="goTo('/exportnote/outbound/create')">
              <v-list-item-title id="exportnote" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group 55.png"
                  />
                  <p id="exportnotetitle" class="ml-3 mt-3 sidenavbar">
                    หนังสือส่งออก
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="goTo('/exportnote/internal/create')">
              <v-list-item-title id="internal" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/icon_new.png"
                  />
                  <p id="stamptitle" class="ml-3 mt-3 sidenavbar">
                    หนังสือภายใต้กระทรวงฯ
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-group>
              <template v-slot:activator>
                <v-list-item-title id="setup" class="subtitle-2">
                  <v-row class="ma-0">
                    <img
                      class="mt-2"
                      width="22px"
                      height="22px"
                      src="./assets/menu_Left/Asset 14@4x.png"
                    />
                    <p id="setuptitle" class="ml-3 mt-3 sidenavbar">
                      หนังสือเพิ่มเติม
                    </p>
                  </v-row>
                </v-list-item-title>
              </template>
              <v-list-item>
                <v-list-item @click="goTo('/exportnote/stamp/create')">
                  <v-list-item-title id="stamp" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Group2.png"
                      />
                      <p id="stamptitle" class="ml-3 mt-3 sidenavbar">
                        หนังสือประทับตรา
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <!-- ADD NEW TEMPLATE -->
                <!-- <v-list-item @click="gotoNewTemplate('regularity')"> -->
                <v-list-item @click="goTo('/newtemplate/regularity/create')">
                  <v-list-item-title id="regularity" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                      src="./assets/menu_Left/Group 80.png"
                      />
                      <p id="regularitytitle" class="ml-3 mt-3 sidenavbar">
                        หนังสือระเบียบ
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item @click="goTo('/newtemplate/announce/create')">
                  <v-list-item-title id="announce" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Group 80.png"
                      />
                      <p id="announcetitle" class="ml-3 mt-3 sidenavbar">
                        หนังสือประกาศ
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item @click="goTo('/newtemplate/directive/create')">
                  <v-list-item-title id="directives" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Group 80.png"
                      />
                      <p id="directivestitle" class="ml-3 mt-3 sidenavbar">
                        หนังสือคำสั่ง
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item @click="goTo('/newtemplate/rules/create')">
                  <v-list-item-title id="rules" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                       src="./assets/menu_Left/Group 80.png"
                      />
                      <p id="rulestitle" class="ml-3 mt-3 sidenavbar">
                        หนังสือข้อบังคับ
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
            </v-list-group>
            <v-divider></v-divider>

            <!-- END NEW TEMPLATE -->
            <v-list-item @click="goTo('/inboundall')">
              <v-list-item-title id="recievein" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group 56.png"
                  />
                  <p id="recieveintitle" class="ml-3 mt-3 sidenavbar">
                    ทะเบียนรับเข้า
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="goTo('/outboundall')">
              <v-list-item-title id="recieveout" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group 53.png"
                  />
                  <p id="recieveouttitle" class="ml-3 mt-3 sidenavbar">
                    ทะเบียนรับส่ง
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>
            <v-list-group
              v-if="
                this.$VUE_APP_EMAIL === 'true' || this.$VUE_APP_ECMS === 'true'
              "
            >
              <template v-slot:activator>
                <v-list-item-title id="setup" class="subtitle-2">
                  <v-row class="ma-0">
                    <img
                      class="mt-2"
                      width="22px"
                      height="22px"
                      src="./assets/menu_Left/Asset 14@4x.png"
                    />
                    <p id="setuptitle" class="ml-3 mt-3 sidenavbar">
                      การรับ-ส่งหนังสือ
                    </p>
                  </v-row>
                </v-list-item-title>
              </template>
              <v-list-item>
                <v-list-item @click="goTo('/waitingsendemail')">
                  <v-list-item-title id="emailinbound" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Asset 13@4x.png"
                      />
                      <p id="waitingemail" class="ml-3 mt-3 sidenavbar">
                        เอกสารรอส่ง
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item v-if="userrole == 'sarabun'">
                <v-list-item
                  @click="goTo('/ecmsemailinbound')"
                  v-if="userrole == 'sarabun'"
                >
                  <v-list-item-title id="ecmsemailinbound" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Asset 12@4x.png"
                      />
                      <p id="emailinbound" class="ml-3 mt-3 sidenavbar">
                        เอกสารรับเข้า
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item v-if="userrole == 'sarabun'">
                <v-list-item
                  @click="goTo('/ecmsemailoutbound')"
                  v-if="userrole == 'sarabun'"
                >
                  <v-list-item-title id="ecmsemailoutbound" class="subtitle-2">
                    <v-row class="ma-0">
                      <img
                        class="mt-2"
                        width="22px"
                        height="22px"
                        src="./assets/menu_Left/Asset 11@4x.png"
                      />
                      <p id="emailoutbound" class="ml-3 mt-3 sidenavbar">
                        เอกสารส่งออก
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
            </v-list-group>

            <v-divider></v-divider>

            <v-list-item @click="goTo('/reservenumber')">
              <v-list-item-title id="reservenumber" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/icon_book_que_1@4x.png"
                  />
                  <p id="reservenumber" class="ml-3 mt-3 sidenavbar">
                    การจองเลข
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>
            <v-divider
              v-if="
                userrole == 'admin' ||
                (userrole == 'sarabun' && this.$VUE_APP_EMAIL === 'true')
              "
            ></v-divider>
            <v-list-group
              v-if="
                userrole == 'admin' ||
                (userrole == 'sarabun' && this.$VUE_APP_EMAIL === 'true')
              "
            >
              <template v-slot:activator>
                <v-list-item-title id="setup" class="subtitle-2">
                  <v-row class="ma-0">
                    <img
                      class="mt-2"
                      width="22px"
                      height="22px"
                      src="./assets/menu_Left/Frame-1.png"
                    />
                    <p id="setuptitle" class="ml-3 mt-3 sidenavbar">
                      การตั้งค่า
                    </p>
                  </v-row>
                </v-list-item-title>
              </template>
              <v-list-item v-if="userrole == 'admin'">
                <v-list-item
                  v-if="userrole == 'admin'"
                  @click="$router.push('/sysconfigmain')"
                >
                  <v-list-item-title id="setup-system" class="subtitle-2">
                    <v-row>
                      <v-icon class="ml-3" medium color="darken-2">
                        mdi-desktop-classic
                      </v-icon>
                      <p id="setup-user-title" class="ml-3 mt-3 sidenavbar">
                        การตั้งค่าระบบ
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item v-if="userrole == 'admin'">
                <v-list-item
                  v-if="userrole == 'admin'"
                  @click="goTo('/setrolesecretary')"
                >
                  <v-list-item-title id="setup-user" class="subtitle-2">
                    <v-row>
                      <v-icon class="ml-3" medium color="darken-2">
                        mdi-account-multiple-outline
                      </v-icon>
                      <p id="setup-user-title" class="ml-3 mt-3 sidenavbar">
                        ตั้งค่าผู้ใช้งาน
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item
                v-if="
                  this.$VUE_APP_EMAIL === 'true' &&
                  (userrole == 'admin' || userrole == 'sarabun')
                "
              >
                <v-list-item
                  v-if="
                    this.$VUE_APP_EMAIL === 'true' &&
                    (userrole == 'admin' || userrole == 'sarabun')
                  "
                  @click="goTo('/agency')"
                >
                  <v-list-item-title id="setup-agency" class="subtitle-2">
                    <v-row>
                      <v-icon class="ml-3" medium color="darken-2">
                        mdi-account-multiple-outline
                      </v-icon>
                      <p id="setup-user-title" class="ml-3 mt-3 sidenavbar">
                        ตั้งค่าหน่วยงาน
                      </p>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </v-list-item>
            </v-list-group>
            <v-list-item v-if="userrole == 'admin'">
              <v-list-item-title
                @click="goTo('/reservehistory')"
                id="reservehistory"
                class="subtitle-2"
              >
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/icon_history_que_1@4x.png"
                  />
                  <p id="reservenumber" class="ml-3 mt-3 sidenavbar">
                    ประวัติการจองเลข
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item @click="logOut">
              <v-list-item-title id="logout" class="subtitle-2">
                <v-row class="ma-0">
                  <img
                    class="mt-2"
                    width="22px"
                    height="22px"
                    src="./assets/menu_Left/Group-1.png"
                  />
                  <p id="logouttitle" class="ml-3 mt-3 sidenavbar">
                    ออกจากระบบ
                  </p>
                </v-row>
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-content class="color-background">
      <router-view :key="$route.fullPath"> </router-view>
      <v-footer
        app
        v-if="
          $router.currentRoute.path != '/savemessage' &&
          $router.currentRoute.path != '/to' &&
          $router.currentRoute.path != '/forward' &&
          $router.currentRoute.path != '/review' &&
          $router.currentRoute.path != '/sign' &&
          $router.currentRoute.path != '/pass' &&
          $router.currentRoute.path != '/receivenote' &&
          $router.currentRoute.path != '/alreadydone' &&
          $router.currentRoute.path != '/receivenotedraft' &&
          !$router.currentRoute.path.includes('/savemessagedraft/') &&
          !$router.currentRoute.path.includes('/exportnote/') &&
          !$router.currentRoute.path.includes('/exportnotedraft/') &&
          !$router.currentRoute.path.includes('/document/') &&
          !$router.currentRoute.path.includes('/flow/') &&
          $router.currentRoute.path != '/stamp' &&
          $router.currentRoute.path != '/internal' &&
          $router.currentRoute.path != '/ecms' &&
          $router.currentRoute.path != '/emaildraft' &&
          $router.currentRoute.path != '/waitingemail' &&
          $router.currentRoute.path != '/waitingsendemail' &&
          $router.currentRoute.path != '/to' &&
          !$router.currentRoute.path.includes('/newtemplate/regularity') && //ถ้าไม่มี path จะไม่ขึ้น footer บันทึกร่าง
          !$router.currentRoute.path.includes('/newtemplate/announce') &&
          !$router.currentRoute.path.includes('/newtemplate/directive') &&
          !$router.currentRoute.path.includes('/newtemplate/rules')
        "
        fixed
        padless
      >
        <v-col md="1" class="text-center grey--text" style="font-size: 0.8em">
        </v-col>
        <v-col md="10" class="text-center grey--text" style="font-size: 0.8em">
          Copyright © 2020, All right reserved.ETDA | Electronic Transactions
          Development Agency
        </v-col>
        <v-col md="1" class="text-center grey--text" style="font-size: 0.8em">
          v. 22.11.1.1
        </v-col>
      </v-footer>

      <v-footer
        v-if="
          $router.currentRoute.path == '/savemessage' ||
          $router.currentRoute.path == '/to' ||
          $router.currentRoute.path == '/forward' ||
          $router.currentRoute.path == '/review' ||
          $router.currentRoute.path == '/sign' ||
          $router.currentRoute.path == '/pass' ||
          $router.currentRoute.path == '/receivenote' ||
          $router.currentRoute.path == '/alreadydone' ||
          $router.currentRoute.path == '/receivenotedraft' ||
          $router.currentRoute.path.includes('/savemessagedraft/') ||
          $router.currentRoute.path.includes('/exportnote/') ||
          $router.currentRoute.path.includes('/exportnotedraft/') ||
          $router.currentRoute.path.includes('/document/') ||
          $router.currentRoute.path.includes('/flow/') ||
          $router.currentRoute.path == '/stamp' ||
          $router.currentRoute.path == '/internal' ||
          $router.currentRoute.path == '/ecms' ||
          $router.currentRoute.path == '/emaildraft' ||
          $router.currentRoute.path == '/waitingemail' ||
          $router.currentRoute.path == '/waitingsendemail' ||
          $router.currentRoute.path.includes('/newtemplate/')
        "
        padless
      >
        <v-col md="1" class="text-center grey--text" style="font-size: 0.8em">
        </v-col>
        <v-col md="10" class="text-center grey--text" style="font-size: 0.8em">
          Copyright © 2020, All right reserved.ETDA | Electronic Transactions
          Development Agency
        </v-col>
        <v-col md="1" class="text-center grey--text" style="font-size: 0.8em">
          v. 22.11.1.1
        </v-col>
      </v-footer>
    </v-content>
  </v-app>
</template>

<style>
input::placeholder {
  font-size: 13px !important;
}
/* .v-navigation-drawer__content {
  overflow-y: hidden !important;
} */
/* .v-navigation-drawer {
  z-index: 0 !important;
} */
@font-face {
  font-family: "Sarabun";
  src: local("Sarabun"),
    url(./fonts/Sarabun/Sarabun-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "Sarabun-Thin";
  src: local("Sarabun-Thin"),
    url(./fonts/Sarabun-Thin/Sarabun-Regular.ttf) format("truetype");
}

/* @font-face {
  font-family: "THSarabunNew";
  src: local("THSarabunNew"),
    url(./fonts/THSarabunNew/THSarabunNew.ttf) format("truetype");
} */
@font-face {
  font-family: "Kanit";
  src: local("Kanit"), url(./fonts/Kanit/Kanit-Regular.ttf) format("truetype");
}
</style>
<style>
.v-list-item--link::before {
  background-color: white;
}

.sidenavbar {
  font-size: 1.2em;
}
.color-background {
  background-color: var(--v-background-base) !important;
}

.color-toptap {
  background-color: var(--v-toptap-base) !important;
}
.color-toptaptext {
  color: var(--v-toptaptext-base) !important;
}
.color-toptaphamburger {
  background-color: var(--v-toptaphamburger-base) !important;
}
.color-topheadsystem {
  background-color: var(--v-topheadsystem-base) !important;
}
.color-create_button {
  background-color: var(--v-create_button-base) !important;
}
</style>
<script>
import { isMobile, isTablet } from "mobile-device-detect";
import axios from "axios";
// import jwt_decode from "jwt-decode";

// import { tr } from 'date-fns/locale';

// import HelloWorld from './components/HelloWorld';
export default {
  name: "App",
  tempDoc: "",
  created() {
    let curVal = localStorage.getItem("username");
    let curRole = localStorage.getItem("userrole");

    this.timer = setInterval(() => {
      const newRole = localStorage.getItem("userrole");
      if (newRole !== curRole) {
        curRole = newRole;
        this.userrole = curRole;
      }

      const newVal = localStorage.getItem("username");

      if (newVal !== curVal) {
        curVal = newVal;
        this.username = curVal;
      }
    }, 1000);

    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        API_ACCESS_KEY: this.$VUE_APP_ACCESS_KEY_USER_MNGT,
      },
    };

    axios
      .get(this.urlUserAuth + localStorage.getItem("userMgntId"), config)
      .then((response) => {
        this.isAD = response.data.isAD;
        this.isAD = true;
      })
      .catch((error) => {
        if (error.response?.status == 401) {
          this.getRefreshToken();
        }
        console.log(error);
      });
  },
  computed: {},

  data() {
    return {
      snackbar: this.$store.getters.getSnackbar,
      text: this.$store.getters.getSnackbarMessage,
      timeout: this.$store.getters.getSnackbarTimeout,

      scrollPos: 0,
      themes: {
        light: {
          primary: "#3f51b5",
          secondary: "#b0bec5",
          anchor: "#8c9eff",
        },
      },
      account: false,
      systemNameLong: this.$VUE_APP_SYSTEM_NAME_LONG,
      systemNameShort: this.$VUE_APP_SYSTEM_NAME_SHORT,
      urlApi: this.$VUE_APP_URL_API,
      email: this.$VUE_APP_EMAIL === "true",
      ecms: this.$VUE_APP_ECMS === "true",
      mini: null,
      isMobile: isMobile,
      isTablet: isTablet,
      lastChange: null,
      timer: null,
      timerVPN: null,
      userrole: localStorage.getItem("userrole"),
      username: localStorage.getItem("username"),
      drawer: false,
      group: null,
      styleObjectQuick: { background: "#FFF9EC", border: "3px solid #F5BE41" },
      styleObjectQuicker: {
        background: "#FFF7EA",
        border: "3px solid #F18E07",
      },
      styleObjectQuickest: {
        background: "#FFF7F7",
        border: "3px solid #F52F1C",
      },
      workListedPagenation: {
        pageNumber: 0,
        numberOfPage: 10,
        isNext: false,
      },
      documentTypeSelected: "ALL",
      isAD: false,
      urlUserAuth: this.$VUE_APP_URL_API_AUTHEN + "api/User/",
    };
  },

  mounted() {
    // console.log("email");
    // console.log(this.email);
    // console.log(this.$VUE_APP_EMAIL);
    // console.log("ecms");
    // console.log(this.ecms);
    // console.log(this.$VUE_APP_ECMS);
  },

  watch: {
    getUsername() {},
    group() {
      // this.drawer = false;
    },
  },
  methods: {
    checkDrawer() {},
    goToEditUser() {
      let userId = localStorage.getItem("userMgntId");
      this.$router
        .push({
          name: "edituser",
          params: {
            userId: userId,
            role: "user",
          },
        })
        .catch(() => {});
    },

    goTo(destination) {
      this.$router.push(destination).catch(() => {});
      this.drawer = !this.drawer;
    },
    openDrawer() {
      this.drawer = !this.drawer;
    },
    gotoStamp() {
      this.drawer = !this.drawer;
      this.$router
        .push({
          name: "stamp",
          params: {
            isStampDocument: true,
          },
        })
        .catch(() => {});
    },
    gotoNewTemplate(inputType) {
      this.drawer = !this.drawer;
      this.$router
        .push({
          name: "newtemplate",
          params: {
            docTypeName: inputType,
            action:"create",
          },
        })
        .catch(() => {});
    },
    gotoInternal() {
      this.drawer = !this.drawer;
      this.$router
        .push({
          name: "internal",

          params: {
            IsInternal: true,
          },
        })
        .catch(() => {});
    },
    logOut() {
      this.$store.dispatch("setSnackbarToken", false);
      localStorage.clear();
      this.$router.push("/").catch(() => {});
    },
    fnChangePassword() {
      if (this.$router.currentRoute.path != "/changepassword") {
        this.$router.push("/changepassword").catch(() => {});
      }
    },
  },
};
</script>
